
import { Activity } from 'src/services/activities/activities.types';
import { rootApi } from '../rootApi';
import { ITask, CreateTaskDto, UpdateTaskDto } from './tasks.types';
import { APIResponse, HTTPRequestType, PaginatedResponse } from '../api.types';

const tasksApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({

    getTask: builder.query<ITask, { taskId: string }>({
      query: (data) => ({
        url: `/tasks/${data.taskId}`,
      }),
      providesTags: (_result, _error, arg) => [{ type: 'Tasks', id: arg.taskId }]
    }),
    getMyTasks: builder.query<PaginatedResponse<ITask>, { page: number; perPage: number, searchQuery?: string, dueMarker?: string }>({
      query: (data) => ({
        url: `/tasks/my-tasks`,
        params: {
          page: data.page,
          per_page: data.perPage,
          search_query: data.searchQuery,
          due_marker: data.dueMarker,
        },
      }),
      providesTags: (_result, _error, arg) => [{ type: 'Tasks' }]
    }),
    getOrgTasks: builder.query<PaginatedResponse<ITask>, { page: number; perPage: number, searchQuery?: string, dueMarker?: string }>({
      query: (data) => ({
        url: `/tasks`,
        params: {
          page: data.page,
          per_page: data.perPage,
          search_query: data.searchQuery,
          due_marker: data.dueMarker,
        },
      }),
      providesTags: (_result, _error, arg) => [{ type: 'Tasks' }]
    }),

    getTasksByDeal: builder.query<PaginatedResponse<ITask>, { dealId: string; page: number; perPage: number }>({
      query: (data) => ({
        url: `/tasks/deals/${data.dealId}?page=${data.page}&per_page=${data.perPage}`,
      }),
      providesTags: (_result, _error, arg) => [{ type: 'DealTasks', id: arg.dealId }]
    }),

    getTaskActivities: builder.query<PaginatedResponse<Activity>, { page: number; perPage: number, taskId: string }>({
      query: (data) => ({
        url: `/deal-flow/deals/${data.taskId}/activities`,
        params: {
          page: data.page,
          per_page: data.perPage
        }
      })
    }),

    createTask: builder.mutation<APIResponse, CreateTaskDto>({
      query: (data) => ({
        url: `/tasks`,
        method: HTTPRequestType.POST,
        data,
      }),
      invalidatesTags: (_result, _error, arg) => {
        const tags: any[] = [{ type: 'Tasks' }];

        if (arg.deal_id) {
          tags.push({ type: 'DealTasks', id: arg.deal_id });
        }

        return tags;
      },
    }),
    updateTask: builder.mutation<APIResponse, { taskId: string; data: UpdateTaskDto }>({
      query: ({ taskId, data }) => ({
        url: `/tasks/${taskId}`,
        method: HTTPRequestType.PUT,
        data,
      }),
      invalidatesTags: (_result, _error, arg) => [{ type: 'Tasks', id: arg.taskId }, { type: 'Tasks' }],
    }),
    markTaskCompleted: builder.mutation<APIResponse, { taskId: string; }>({
      query: ({ taskId }) => ({
        url: `/tasks/${taskId}/mark-completed`,
        method: HTTPRequestType.POST
      }),
      invalidatesTags: (_result, _error, arg) => [{ type: 'Tasks', id: arg.taskId }, { type: 'Tasks' }],
    }),
    removeTask: builder.mutation<APIResponse, { taskId: string }>({
      query: (data) => ({
        url: `/tasks/${data.taskId}`,
        method: HTTPRequestType.DELETE,
      }),
      invalidatesTags: (_result, _error, arg) => [{ type: 'Tasks' }],
    })
  }),
});

export const {
  useGetTaskQuery,
  useLazyGetTaskQuery,
  useGetMyTasksQuery,
  useGetOrgTasksQuery,
  useCreateTaskMutation,
  useUpdateTaskMutation,
  useMarkTaskCompletedMutation,
  useRemoveTaskMutation,
  useGetTaskActivitiesQuery
} = tasksApi;
